import domtoimage from '@/helpers/dom-to-image'
import fileSaver from 'file-saver'

L.Control.EasyPrint = L.Control.extend({
  options: {
    position: 'topleft',
    filename: 'map',
    exportOnly: false,
    hidden: false,
    tileWait: 500
  },

  onAdd: function () {
    this.mapContainer = this._map.getContainer()
    const container = L.DomUtil.create('div', 'leaflet-control-image leaflet-bar leaflet-control')
    if (!this.options.hidden) {
      this.link = L.DomUtil.create('a', '', container)
      L.DomUtil.create('i', "Icon IconSaveAsPng", this.link)
      this.link.title = 'Сохранить как .PNG'
      L.DomEvent.addListener(this.link, 'click', this.printMap, this)

      L.DomEvent.disableClickPropagation(container)
    }
    return container
  },

  printMap: function (event, filename) {
    if (filename) {
      this.options.filename = filename
    }

    this.originalState = {
      mapWidth: this.mapContainer.clientWidth,
      widthWasAuto: false,
      widthWasPercentage: false,
      mapHeight: this.mapContainer.clientHeight,
      zoom: this._map.getZoom(),
      center: this._map.getCenter()
    }
    this._map.fire("easyPrint-start", { event: event })
    return this._printOperation('CurrentSize')
  },

  _toggleControls: function (show) {
    const controlContainer = document.getElementsByClassName("leaflet-control-container")[0];
    if (show) return controlContainer.style.display = 'block';
    controlContainer.style.display = 'none';
  },

  _printOperation: function (sizemode) {
    const plugin = this
    this._toggleControls(false)
    domtoimage.toPng(plugin.mapContainer, {
      width: parseInt(this.originalState.mapWidth),
      height: parseInt(this.originalState.mapHeight)
    })
      .then((dataUrl) => {
        this._toggleControls(true)
        const blob = plugin._dataURItoBlob(dataUrl)
        fileSaver.saveAs(blob, plugin.options.filename + '.png')
        plugin._map.fire("easyPrint-finished")
      })
      .catch((error) => {
        this._toggleControls(true)
        console.error('Print operation failed', error)
      })
  },

  _dataURItoBlob: function (dataURI) {
    const byteString = atob(dataURI.split(',')[1])
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    const ab = new ArrayBuffer(byteString.length)
    const dw = new DataView(ab)
    for(let i = 0; i < byteString.length; i++) {
      dw.setUint8(i, byteString.charCodeAt(i))
    }
    return new Blob([ab], {type: mimeString})
  }
})

L.easyPrint = function(options) {
  return new L.Control.EasyPrint(options)
}



// WEBPACK FOOTER //
// ./src/helpers/leaflet-image.js